export const menuItems = [
  {
    id: 1,
    label: "Dashboard",
    icon: "bx-home-circle",
    link: "/dashboard",
  },
  {
    id: 2,
    label: "Info",
    isTitle: true,
  },
  {
    id: 3,
    label: "Info",
    icon: "bx bx-clipboard",
    subItems: [
      {
        id: 7,
        label: "Regulations",
        link: "/info/Regulations",
        parentId: 3,
      },
      {
        id: 6,
        label: "Question",
        link: "/info/Question",
        parentId: 3,
      },
      {
        id: 5,
        label: "Privilege",
        link: "/info/Privilege",
        parentId: 3,
      },
    ],
  },

  // {
  //   id: 2,
  //   label: "Management",
  //   isTitle: true,
  // },
  // {
  //   id: 4,
  //   label: "Management",
  //   icon: "bx bx-cog toggle-right",
  //   subItems: [
  //     {
  //       id: 4,
  //       label: "organization",
  //       link: "/managment/organization",
  //       parentId: 4,
  //     },

  //   ],
  // },
];
